
import { Link, Outlet,NavLink, useLoaderData, useNavigation } from "react-router-dom"
import { Form } from "react-router-dom";
import { useEffect, useState } from "react";
import { Select } from "../components/Select";
import { Button } from "../components/Button";
import { TextArea } from "../components/TextField";
import { addVehicleNote } from "../services/api";
import mixpanel from "../services/mixpanel";
import { getUserId } from "../services/helpers";

export function VehicleDetails(){
	const loaderData  = useLoaderData();
	const vehicleData = loaderData.vehicleDetails.details;
	const [showDialog, setShowDialog] = useState(false);
	const [isSubmitting,setIsSubmitting] = useState(false);


	useEffect(()=>{
		mixpanel.identify(getUserId());
	},[]);



		const handleCloseDialog = () => {
			setShowDialog(false);

		};

		function addNote(event){
			setIsSubmitting(true);
			event.preventDefault();
			const form = document.getElementById("addVehicleNote");
			const formData = new FormData(form);

			const payload = {
				"tag" : formData.get("tag"),
				"vehicle_id" : vehicleData.license_plate,
				"comment" : formData.get("comment")
			}

			if (formData.get('comment') == ""){
				alert("You need to add details to the note");
				setIsSubmitting(false);
				return;
			}

			addVehicleNote(payload).then(async(response)=>{
				const result = await response.json();
				// // console.
				// console.log("result",result);
				if (result["note_id"]){
					handleCloseDialog();
					alert("Added vehicle note");
				}

			setIsSubmitting(false);
			});


		}

	return (
		<main id="VehicleDetails">
		<h1>Vehicle Details</h1>
		<Link to="/dashboard/vehicles">Back to All Vehicles</Link>
		<div id="page-detail-card">
			<div id="header-section">
				<div id="start">
					<h3>{vehicleData.license_plate}</h3>
					<p style={{"margin": "0px"}}>{vehicleData.vehicle_name} ({vehicleData.vehicle_year})</p>
					<small>{vehicleData.vin}</small>
					<p style={{"marginTop": "8px"}}><small>Roadworthy</small> {vehicleData.roadworthy_expiry}</p>
					<p><small>Insurance Provider</small> {vehicleData.insurance_provider}</p>
					<p><small>Insurance Expiry</small> {vehicleData.insurance_expiry}</p>
				</div>
				<div id="end">
					<p>Owner: <strong><Link to={`/dashboard/members/u/${vehicleData.customer_id}/vehicles`}>{vehicleData.customer_name}</Link></strong></p>
					<p>{vehicleData.phone_number}</p>

					<div className="detail-actions mt-1">
						<Link to={`/dashboard/services/add_ticket`} state={{customer_id : vehicleData.customer_id,vehicle_id: vehicleData.vehicle_id}} className="actions">Add Service Ticket</Link>
						{/* <Link to={`/dashboard/vehicles/${vehicleData.license_plate}/add_service`} className="actions">Add Service Ticket</Link> */}
						<Link onClick={()=> setShowDialog(prev=> !prev)}>Add A Vehicle Note</Link>
					</div>

				</div>
			</div>
			<div id="action-row">
				{/* <NavLink className={({ isActive }) => isActive ? "active-subnav" : ""} end to="">Details</NavLink> */}
				<NavLink className={({ isActive }) => isActive ? "active-subnav" : ""} to="services">Service History</NavLink>
				<NavLink className={({ isActive }) => isActive ? "active-subnav" : ""} to="notes">Notes</NavLink>
			</div>
			<div id="body-section">
				<Outlet context={loaderData} />
			</div>

		</div>

		{showDialog && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="addVehicleNote" type="post" onSubmit={addNote}>
							<div className="dialog-header">
								<h3>Add A Note to The Vehicle</h3>
							</div>
							<div className="dialog-content">
								<div className="col-6">
									<Select
										label="Type of Note"
										options={["Info","Critical","Reminder"]}
										name="tag"
										// value={urgencyField}
										// onChange={(e) => setUrgencyField(e.target.value)}
									/>
								</div>
								<TextArea
								// value={descriptionField}
									label="Note Details"
									name="comment"
									// onChange={(e) => setDescriptionField(e.target.value)}
								/>
							</div>
							<div className="dialog-footer">
								<Button onClick={handleCloseDialog} color="red" label="Cancel"/>
								<Button
									label={isSubmitting ? "Submitting...":"Add Note"}
									color={isSubmitting ? "black": "green"}
									type="submit"
									disabled={isSubmitting}
								/>
							</div>
						</Form>
					</div>
				</div>
			)}

		</main>
	)
}